export default __webpack_public_path__ + "static/cities-04ae39f5ef8b677240dee007d6eb4911.png";